export const MICROSCOPE_ENDPOINT = 'https://microscope.prod.atl-paas.net';
export const STATLAS_ENDPOINT = 'https://statlas.prod.atl-paas.net';
